<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <b-modal
      id="finance_configuration_category"
      title="ALTERAR CATEGORIA DO FINANCEIRO"
      no-close-on-backdrop
      hide-footer
    >
      <finance-configuration-category
        :category_id="category_id"
        :product_kit_id="product_kit_id"
        :finance_configuration_category="finance_configuration_category"
        @success="handleSuccessFinanceConfigurationCategory"
      />
    </b-modal>
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <!-- Modal new kit type -->
        <b-modal no-close-on-backdrop id="createKitType" hide-footer>
          <template v-slot:modal-title>NOVO TIPO DE KIT</template>
          <form v-on:submit="createKitType" method="post">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <LabelRequiredField label="NOME" />
                <input
                  type="text"
                  v-model="kit_type_name"
                  class="form-control"
                />
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <WarningRequiredFields />
                <ErrorsMessages :errors="errors" />
              </div>
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
              >
                <v-btn
                  :disabled="loadingCreateKitType"
                  type="submit"
                  class="btn-save"
                >
                  <i class="fas fa-save mr-2 text-twenty"></i>
                  {{ loadingCreateKitType ? "CARREGANDO" : "SALVAR" }}
                </v-btn>
              </div>
            </div>
          </form>
        </b-modal>
        <!-- /Modal new kit type -->
        <div class="row">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
            <v-btn class="btn-return" v-on:click="handleToBack">
              <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
            </v-btn>
          </div>
          <div class="col-xl-6 col-lg-5 col-md-5 col-sm-5 col-12 pt-0">
            <h1 class="title-pages pt-1">KIT: {{ description }}</h1>
          </div>
          <div
            class="col-xl-5 col-lg-5 col-md-5 col-sm-4 col-12 pt-0 text-right"
          >
            <confirmation-dialog
              v-if="permission('remove', 'product_kit')"
              message-title="EXCLUIR?"
              message-body="Deseja realmente apagar o produto do kit?"
              open-class="btn-delete"
              open-left-icon="fa-trash"
              open-text="EXCLUIR"
              @yes="deleteProductKit"
            />
          </div>
        </div>
        <form v-on:submit="update" method="post">
          <WarningMessage
            v-if="!permission('edit', 'product_kit')"
            message="Você não tem permissão para modificar kits de produtos"
          />
          <div class="row">
            <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 col-12 d-flex">
              <v-select
                label="Tipo de kit"
                :disabled="!permission('edit', 'product_kit')"
                :items="kitTypes"
                item-text="name"
                item-value="id"
                v-model="kit_type_id"
                outlined
                dense
              />
              <v-btn
                type="button"
                class="btn-add mt-1 ml-3"
                v-if="permission('edit', 'product_kit')"
                @click="$bvModal.show('createKitType')"
              >
                <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
              </v-btn>
            </div>
            <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 col-12 pb-0">
              <v-text-field
                :disabled="!permission('edit', 'product_kit')"
                v-model="description"
                outlined
                autofocus
                label="Descrição"
                dense
              />
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-0 pb-0">
              <v-text-field
                :disabled="!permission('edit', 'product_kit')"
                v-model="products_cost"
                v-on:keyup="handleValueProductsCost"
                outlined
                label="Valor de custo*"
                dense
              />
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-0 pb-0">
              <v-text-field
                :disabled="!permission('edit', 'product_kit')"
                v-on:keyup="handleValueProfit"
                v-model="profit"
                outlined
                label="Lucro (%)"
                dense
              />
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 pt-0 pb-0">
              <v-text-field
                :disabled="!permission('edit', 'product_kit')"
                v-on:keyup="handleValueSalePrice"
                v-model="product_cost"
                outlined
                label="Valor da venda"
                dense
              />
            </div>
            <div
              class="col-md-12 pt-0 pb-0"
              v-if="permission('read', 'financial')"
            >
              <v-text-field
                disabled
                outlined
                dense
                label="CATEGORIA DO FINANCEIRO"
                :value="
                  finance_configuration_category_name
                    ? finance_configuration_category_name
                    : 'NÃO INFORMADO'
                "
              />
            </div>
            <div class="col-md-12">
              <label>REAJUSTE</label>
              <select class="form-control" v-model="readjustment">
                <option value="REAJUSTE_MANUAL">REAJUSTE MANUAL</option>
                <option value="REAJUSTE_VALOR_MEDIO">
                  REAJUSTE VALOR MÉDIO (AUTOMÁTICO)
                </option>
                <option value="REAJUSTE_MAIOR_VALOR">
                  REAJUSTE MAIOR VALOR (AUTOMÁTICO)
                </option>
              </select>
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
            >
              <WarningRequiredFields v-if="permission('edit', 'product_kit')" />
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <h6 class="mb-0 worksansr">
                Criação:
                {{ formatDate(created_at) }}
              </h6>
              <h6 class="mb-0 worksansr">
                Última alteração:
                {{ formatDate(updated_at) }}
              </h6>
            </div>
            <div
              class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
            >
              <v-btn
                v-if="permission('read', 'financial')"
                @click="handleModalFinance"
                class="btn-i"
              >
                <i class="fas fa-edit mr-2 text-twenty"></i>
                ALTERAR CATEGORIA DO FINANCEIRO
              </v-btn>
              <v-btn
                v-if="permission('edit', 'product_kit')"
                :disabled="loadingUpdate"
                type="button"
                v-on:click="update"
                class="btn-save ml-2"
              >
                <i class="fas fa-save mr-2 text-twenty"></i>
                {{ loadingUpdate ? "CARREGANDO" : "SALVAR" }}
              </v-btn>
            </div>
          </div>
        </form>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row bg-white">
            <div
              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 d-flex align-items-center"
            >
              <h1 class="title-pages mb-0">PRODUTOS</h1>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 text-right">
              <v-btn
                v-if="permission('edit', 'product_kit')"
                class="btn-add"
                @click="handleModalAddProduct"
              >
                <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
              </v-btn>
            </div>
          </div>
        </div>
        <!-- MODAL PRODUTO -->
        <b-modal
          size="lg"
          no-close-on-backdrop
          hide-footer
          id="modalProduct"
          title="PRODUTOS"
        >
          <h1 class="subtitles">PESQUISAR POR NOME:</h1>
          <v-text-field
            @keyup="handleFilterProducts"
            v-model="searchProduct"
            append-icon="mdi-magnify"
            label="Digite sua pesquisa"
            single-line
          />
          <b-overlay :show="loadingProducts" opacity="0.99">
            <v-data-table
              dense
              :headers="[{ sortable: false, value: 'item' }]"
              :items="products"
              item-key="`${type}`/${id}"
              :footer-props="{
                'items-per-page-options': [10, 25],
                'items-per-page-text': 'Mostrar ',
              }"
              :options.sync="optionsProducts"
              :server-items-length="totalProducts"
              @click:row="handleModalCreateProductKitHasProduct"
              height="500px"
            >
              <template v-slot:[`item.item`]="{ item }">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-1">
                  <h6 class="mb-1 mt-1">
                    <span class="text-muted">NOME:</span>
                    {{ item.name }}
                  </h6>

                  <small>
                    <h6 class="mb-1 mt-1">
                      <span class="text-muted">UNIDADE DE MEDIDA:</span>
                      {{ item.unit_of_measurement_name }}
                    </h6>
                  </small>

                  <small>
                    <h6 class="mb-1 mt-1">
                      <span class="text-muted">TIPO:</span>
                      {{ item.type == "PADRAO" ? "PADRÃO" : "EMPRESA" }}
                    </h6>
                  </small>
                </div>
                <!-- MODAL ADICIONAR -->
                <b-modal
                  size="md"
                  no-close-on-backdrop
                  hide-footer
                  :id="`modalAddProduct_${item.id}_${item.type}`"
                  title="ADICIONAR PRODUTO"
                >
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
                  >
                    <h6>
                      {{ item.name }}
                    </h6>
                    <h6>
                      <span class="text-muted">TIPO:</span>
                      {{ item.type == "PADRAO" ? "PADRÃO" : "EMPRESA" }}
                    </h6>

                    <h6>
                      UNIDADE:
                      <LabelRequiredField
                        :label="item.unit_of_measurement_name"
                      />
                    </h6>
                    <input
                      :ref="`product_${item.id}_${item.type}`"
                      type="text"
                      class="form-control"
                    />
                  </div>
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0"
                  >
                    <WarningRequiredFields />
                    <ErrorsMessages :errors="errors" />
                  </div>
                  <div
                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
                  >
                    <v-btn
                      class="btn-add"
                      @click="createProductKitHasProduct(item)"
                    >
                      <i class="fas fa-plus mr-2 text-twenty"></i>
                      ADICIONAR
                    </v-btn>
                  </div>
                </b-modal>
                <!-- /MODAL ADICIONAR -->
              </template>
            </v-data-table>
          </b-overlay>
        </b-modal>
        <!-- /MODAL PRODUTO -->
        <b-overlay :show="loadingProductKitHasProduct" opacity="0.99">
          <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-6 col-sm-8 col-12 pt-0 pb-0">
              <v-text-field
                v-model="searchProducts"
                prepend-inner-icon="mdi-magnify"
                label="Pesquisar produtos adicionados"
                outlined
                dense
              />
            </div>
          </div>
          <div
            class="v-clean p-5 text-center"
            v-show="productsAdded.length == 0"
          >
            <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
          </div>
          <v-data-table
            v-show="productsAdded.length > 0"
            dense
            :headers="[
              {
                text: 'QUANTIDADE',
                sortable: false,
                value: 'amount',
              },
              { text: 'NOME', value: 'product_name', sortable: false },
            ]"
            item-class="v-data-table-uppercase"
            :items="productsAdded"
            :search="searchProducts"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleGetProductKitHasProduct"
          >
            <template v-slot:[`item.product_name`]="{ item }">
              {{ item.product_name }}
              <!-- MODAL EDIT PRODUCT -->
              <b-modal
                size="md"
                no-close-on-backdrop
                hide-footer
                :id="`modalEditProduct_${item.id}`"
                title="EDITAR PRODUTO"
              >
                <div class="col-md-12">
                  <h6>
                    <span class="text-muted">PRODUTO:</span>
                    {{ item.product_name }}
                  </h6>
                  <h6>
                    UNIDADE:
                    {{ item.unit_of_measurement_name }}
                  </h6>

                  <input
                    :disabled="!permission('edit', 'product_kit')"
                    :ref="`amount_${item.id}`"
                    :data-amount="`${item.id}`"
                    :data-amount_ref="`amount_${item.id}`"
                    type="text"
                    :value="`${item.amount}`"
                    class="form-control"
                  />
                  <WarningRequiredFields class="mt-1" />
                  <ErrorsMessages :errors="errors" class="mb-3" />
                  <confirmation-dialog
                    :disabled="!permission('edit', 'product_kit')"
                    message-title="EXCLUIR?"
                    message-body="Deseja realmente apagar o produto do kit?"
                    open-class="btn-delete"
                    open-left-icon="fa-trash"
                    open-text="EXCLUIR"
                    @yes="deleteProductKitHasProduct(item)"
                  />
                  <v-btn
                    v-if="permission('edit', 'product_kit')"
                    v-on:click="handleUpdateAmount(item)"
                    class="btn-save float-right"
                  >
                    <i class="fas fa-save mr-2 text-twenty"></i>SALVAR
                  </v-btn>
                </div>
              </b-modal>
              <!-- /MODAL EDIT PRODUCT -->
            </template>
          </v-data-table>
          <errors-messages :errors="errors" />
        </b-overlay>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import WarningMessage from "../templates/Components/WarningMessage";
import WarningRequiredFields from "../templates/Components/WarningRequiredFields";
import LabelRequiredField from "../templates/Components/LabelRequiredField";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ConfirmationDialog from "../templates/Components/ConfirmationDialog";

import FinanceConfigurationCategory from "../templates/product-kit/finance-configuration-category.vue";

import api from "../services/api";

import toast from "../lib/ToastNotification";

import permission from "../lib/permission";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
  formatDate,
} from "../lib/format";

import routes from "../routes";

import { userData } from "../lib/functions";

export default {
  name: "RestHomeProductKit",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    WarningMessage,
    WarningRequiredFields,
    LabelRequiredField,
    ConfirmationDialog,
    FinanceConfigurationCategory,
  },
  data() {
    return {
      totalProducts: 0,
      optionsProducts: {},
      user_id: "",
      searchProduct: "",
      searchProducts: "",
      rest_home_id: "",
      kitTypes: [],
      products: [],
      productsAdded: [],
      kit_type_id: "",
      product_kit_id: "",
      products_cost: "",
      profit: "",
      product_cost: "",
      description: "",
      readjustment: "REAJUSTE_MANUAL",
      category_id: "",
      finance_configuration_category_name: "",
      created_at: "",
      updated_at: "",
      loadingUpdate: false,
      loadingProducts: false,
      loadingProductKitHasProduct: false,
      loadingCreateKitType: false,
      kit_type_name: "",
      loading: true,
      errors: [],
      finance_configuration_category: [],
    };
  },
  watch: {
    optionsProducts: {
      handler() {
        this.handleFilterProducts();
      },
    },
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    formatPrice,
    formatValueOnKeyUp,
    formatValueToOnlyNumber,
    formatValueToPercentage,
    formatDate,

    handleSuccessFinanceConfigurationCategory() {
      this.get();
    },

    handleModalFinance() {
      this.$bvModal.show("finance_configuration_category");
    },

    handleValueProductCostByRef: function (e) {
      let ref = e.target.dataset.product_cost_ref;
      let value = e.target.value;

      this.$refs[ref].value = formatValueOnKeyUp(value);
    },
    handleValueSalePriceByRef: function (e) {
      let ref = e.target.dataset.product_cost_ref;
      let value = e.target.value;

      this.$refs[ref].value = formatValueOnKeyUp(value);
    },
    handleValueProfit: function (e) {
      let profit = formatValueToPercentage(e.target.value);
      if (profit) {
        let current = formatValueToOnlyNumber(this.products_cost);
        let percentage = profit * current;
        let product_cost = percentage / 100;
        product_cost = parseFloat(product_cost) + parseFloat(current);
        this.product_cost = formatPrice(product_cost);
      } else {
        this.product_cost = formatPrice(0);
      }
    },
    handleValueProductsCost: function (e) {
      this.products_cost = formatValueOnKeyUp(e.target.value);

      let { profit, products_cost } = this;

      if (profit) {
        let current = formatValueToOnlyNumber(products_cost);
        let percentage = profit * current;
        let product_cost = percentage / 100;
        product_cost = parseFloat(product_cost) + parseFloat(current);
        this.product_cost = formatPrice(product_cost);
      } else {
        this.product_cost = formatPrice(0);
      }
    },
    handleValueSalePrice: function (e) {
      let product_cost = formatValueToOnlyNumber(e.target.value);

      this.product_cost = formatValueOnKeyUp(product_cost);

      let { products_cost } = this;

      products_cost = formatValueToOnlyNumber(products_cost);

      if (parseFloat(product_cost) > parseFloat(products_cost)) {
        let profit = parseFloat(product_cost) - parseFloat(products_cost);
        profit = parseFloat(profit) / parseFloat(products_cost);
        profit = parseFloat(profit) * 100;
        if (String(profit).indexOf(".") > -1) {
          profit = profit.toFixed(2);
        }
        this.profit = profit;
      } else {
        this.profit = 0;
      }
    },
    handleGetProductKitHasProduct(item) {
      this.errors = [];
      this.$bvModal.show(`modalEditProduct_${item.id}`);
    },
    handleModalAddProduct() {
      this.$bvModal.show("modalProduct");
    },
    async retrieve() {
      this.rest_home_id = userData().user.rest_home_id;
      this.user_id = userData().user.id;

      const { id } = routes.history.current.params;

      this.product_kit_id = id;

      if (this.errors.length == 0) await this.get();
      if (this.errors.length == 0) await this.getKitTypes();
      if (this.errors.length == 0) await this.financeConfigurationCategory();
    },
    async getKitTypes() {
      try {
        const { rest_home_id } = this;

        let params = {
          rest_home_id,
        };

        const response = await api.get("/rest-home/kit-type/all", {
          params,
        });

        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.kitTypes = types;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleFilterProducts() {
      try {
        this.loadingProducts = true;

        const { page, itemsPerPage } = this.optionsProducts;

        const { rest_home_id, searchProduct } = this;

        let params = {
          rest_home_id,
          filter: searchProduct,
          page,
          itemsPerPage,
        };

        const response = await api.get("/rest-home/product/filter", {
          params,
        });

        const { error, errors, products, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.products = products;
          this.totalProducts = total;
        }

        this.loadingProducts = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update() {
      try {
        this.loadingUpdate = true;

        const {
          user_id,
          product_kit_id,
          rest_home_id,
          kit_type_id,
          products_cost,
          profit,
          product_cost,
          description,
          readjustment,
        } = this;

        let params = {
          user_id,
          id: product_kit_id,
          rest_home_id,
          kit_type_id,
          products_cost,
          profit,
          product_cost,
          description,
          readjustment,
        };

        const response = await api.put("/rest-home/product-kit/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.get();
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async get() {
      try {
        this.loading = true;
        this.errors = [];

        const { rest_home_id, product_kit_id } = this;

        const response = await api.get("/rest-home/product-kit/get", {
          params: { id: product_kit_id, rest_home_id },
        });

        const { kit, error } = response.data;

        if (error) {
          return routes.push({ name: "product_kits" });
        }

        this.kit_type_id = kit.kit_type_id;
        this.description = kit.description;

        if (kit.products_cost) {
          this.products_cost = formatPrice(String(kit.products_cost));
        }

        this.profit = kit.profit;

        if (kit.product_cost) {
          this.product_cost = formatPrice(String(kit.product_cost));
        }
        this.category_id = kit.finance_configuration_category_id;
        this.finance_configuration_category_name =
          kit.finance_configuration_category_name;
        this.readjustment = kit.readjustment;
        this.created_at = kit.created_at;
        this.updated_at = kit.updated_at;
        this.getProductKitsHasProducts();
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getProductKitsHasProducts() {
      try {
        this.loadingProductKitHasProduct = true;

        const { product_kit_id } = this;

        const response = await api.get(
          "/rest-home/product-kit-has-product/paginate",
          {
            params: { product_kit_id },
          }
        );

        const { error, errors, products } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.productsAdded = products;
        }

        this.loadingProductKitHasProduct = false;
      } catch (error) {
        console.log(error);
      }
    },
    async createKitType(event) {
      try {
        event.preventDefault();

        this.loadingCreateKitType = true;

        const { user_id, rest_home_id, kit_type_name } = this;

        let params = {
          user_id,
          rest_home_id,
          name: kit_type_name,
          type: "PRODUTO",
        };

        const response = await api.post("/rest-home/kit-type/create", params);

        const { error, errors } = response.data;

        if (!error) {
          this.$bvModal.hide("createKitType");
          this.kit_type_name = "";
          this.getKitTypes();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreateKitType = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreateProductKitHasProduct(product) {
      this.$bvModal.show(`modalAddProduct_${product.id}_${product.type}`);
    },
    async createProductKitHasProduct(product) {
      try {
        const { id, type } = product;

        let amount = this.$refs[`product_${product.id}_${product.type}`].value;

        const { product_kit_id } = this;

        let params = {
          product_kit_id,
          product_id: id,
          type,
          amount,
        };

        const response = await api.post(
          "/rest-home/product-kit-has-product/create",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide("modalProduct");
          this.get();
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async deleteProductKit() {
      try {
        const { product_kit_id: id } = this;

        let data = { id };

        const response = await api.delete("/rest-home/product-kit/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.errors = [];
          routes.push({
            name: "new-stock",
            query: {
              menu: "items",
              tipo: "products",
              item: "products_kits",
            },
          });
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async deleteProductKitHasProduct(product) {
      try {
        const { user_id } = this;

        const { id } = product;

        let data = { user_id, id };

        const response = await api.delete(
          "/rest-home/product-kit-has-product/delete",
          {
            data,
          }
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.get();
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleUpdateAmount(item) {
      try {
        const { id, type } = item;

        const amount = this.$refs[`amount_${id}`].value;

        let params = { id, type, amount };

        const response = await api.post(
          "/rest-home/product-kit-has-product/update/amount",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$bvModal.hide(`modalEditProduct_${id}`);
          this.get();
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async financeConfigurationCategory() {
      try {
        const response = await api.get(
          "/rest-home/financial/configuration/category-actives"
        );

        const { data } = response.data;

        this.finance_configuration_category = data;
      } catch (error) {
        console.log(error);
      }
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>
